export default __webpack_public_path__ + "static/media/Background 5_00049.29102041.png";